import * as tslib_1 from "tslib";
import { Item, Num, Func, Extant } from '@swim/recon';
import { DateTime } from './../time';
import { Color } from './../color';
import { Interpolator } from './../interpolator';
import { UiValue } from './ui-value';
var DateFunc = (function (_super) {
    tslib_1.__extends(DateFunc, _super);
    function DateFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DateFunc.prototype, "name", {
        get: function () {
            return 'date';
        },
        enumerable: true,
        configurable: true
    });
    DateFunc.prototype.invoke = function (args, stack) {
        var date;
        if (args instanceof Extant) {
            date = DateTime.current();
        }
        else {
            date = args.evaluate(stack).cast(DateTime.Form);
        }
        if (date) {
            return DateTime.Form.mold(date);
        }
        return Item.Absent;
    };
    return DateFunc;
}(Func));
export { DateFunc };
var NowFunc = (function (_super) {
    tslib_1.__extends(NowFunc, _super);
    function NowFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NowFunc.prototype, "name", {
        get: function () {
            return 'now';
        },
        enumerable: true,
        configurable: true
    });
    NowFunc.prototype.invoke = function (args) {
        return Num.valueOf(Date.now());
    };
    return NowFunc;
}(Func));
export { NowFunc };
var BrighterFunc = (function (_super) {
    tslib_1.__extends(BrighterFunc, _super);
    function BrighterFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BrighterFunc.prototype, "name", {
        get: function () {
            return 'brighter';
        },
        enumerable: true,
        configurable: true
    });
    BrighterFunc.prototype.invoke = function (args, stack) {
        var color;
        var k;
        if (args.length >= 2) {
            color = args.getItem(0).evaluate(stack).cast(Color.Form);
            k = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            color = args.evaluate(stack).cast(Color.Form);
        }
        if (color) {
            color = color.brighter(k);
            return Color.Form.mold(color);
        }
        return Item.Absent;
    };
    return BrighterFunc;
}(Func));
export { BrighterFunc };
var DarkerFunc = (function (_super) {
    tslib_1.__extends(DarkerFunc, _super);
    function DarkerFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DarkerFunc.prototype, "name", {
        get: function () {
            return 'darker';
        },
        enumerable: true,
        configurable: true
    });
    DarkerFunc.prototype.invoke = function (args, stack) {
        var color;
        var k;
        if (args.length >= 2) {
            color = args.getItem(0).evaluate(stack).cast(Color.Form);
            k = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            color = args.evaluate(stack).cast(Color.Form);
        }
        if (color) {
            color = color.darker(k);
            return Color.Form.mold(color);
        }
        return Item.Absent;
    };
    return DarkerFunc;
}(Func));
export { DarkerFunc };
var ContrastFunc = (function (_super) {
    tslib_1.__extends(ContrastFunc, _super);
    function ContrastFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ContrastFunc.prototype, "name", {
        get: function () {
            return 'contrast';
        },
        enumerable: true,
        configurable: true
    });
    ContrastFunc.prototype.invoke = function (args, stack) {
        var color;
        var k;
        if (args.length >= 2) {
            color = args.getItem(0).evaluate(stack).cast(Color.Form);
            k = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            color = args.evaluate(stack).cast(Color.Form);
        }
        if (color) {
            color = color.contrast(k);
            return Color.Form.mold(color);
        }
        return Item.Absent;
    };
    return ContrastFunc;
}(Func));
export { ContrastFunc };
var OpacityFunc = (function (_super) {
    tslib_1.__extends(OpacityFunc, _super);
    function OpacityFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OpacityFunc.prototype, "name", {
        get: function () {
            return 'opacity';
        },
        enumerable: true,
        configurable: true
    });
    OpacityFunc.prototype.invoke = function (args, stack) {
        var color;
        var a;
        if (args.length >= 2) {
            color = args.getItem(0).evaluate(stack).cast(Color.Form);
            a = args.getItem(1).evaluate(stack).numberValue();
            if (color && a !== undefined) {
                color = color.alpha(a);
                return Color.Form.mold(color);
            }
        }
        return Item.Absent;
    };
    return OpacityFunc;
}(Func));
export { OpacityFunc };
var InterpolatorFunc = (function (_super) {
    tslib_1.__extends(InterpolatorFunc, _super);
    function InterpolatorFunc(interpolator) {
        var _this = _super.call(this) || this;
        _this.interpolator = interpolator;
        return _this;
    }
    Object.defineProperty(InterpolatorFunc.prototype, "name", {
        get: function () {
            return 'interpolator';
        },
        enumerable: true,
        configurable: true
    });
    InterpolatorFunc.prototype.invoke = function (args, stack) {
        var u = args.evaluate(stack).numberValue();
        if (u !== undefined) {
            u = Math.min(Math.max(0, u || 0), 1);
            var value = this.interpolator.map(u);
            return UiValue.Form.mold(value);
        }
        return Item.Absent;
    };
    return InterpolatorFunc;
}(Func));
export { InterpolatorFunc };
var InterpolateFunc = (function (_super) {
    tslib_1.__extends(InterpolateFunc, _super);
    function InterpolateFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InterpolateFunc.prototype, "name", {
        get: function () {
            return 'inerpolate';
        },
        enumerable: true,
        configurable: true
    });
    InterpolateFunc.prototype.invoke = function (args, stack) {
        var a;
        var b;
        if (args.length >= 2) {
            a = args.getItem(0).evaluate(stack).cast(UiValue.Form);
            b = args.getItem(1).evaluate(stack).cast(UiValue.Form);
        }
        else {
            a = args.evaluate(stack).cast(UiValue.Form);
        }
        if (a !== undefined || b !== undefined) {
            var interpolator = Interpolator.interpolate(a, b);
            return new InterpolatorFunc(interpolator);
        }
        return Item.Absent;
    };
    return InterpolateFunc;
}(Func));
export { InterpolateFunc };
export var UiFunc = {
    Date: new DateFunc(),
    Now: new NowFunc(),
    Brighter: new BrighterFunc(),
    Darker: new DarkerFunc(),
    Contrast: new ContrastFunc(),
    Opacity: new OpacityFunc(),
    Interpolate: new InterpolateFunc(),
    GlobalScope: undefined,
};
UiFunc.GlobalScope = Item.GlobalScope.branch()
    .slot('date', UiFunc.Date)
    .slot('now', UiFunc.Now)
    .slot('brighter', UiFunc.Brighter)
    .slot('darker', UiFunc.Darker)
    .slot('contrast', UiFunc.Contrast)
    .slot('opacity', UiFunc.Opacity)
    .slot('interpolate', UiFunc.Interpolate)
    .commit();
//# sourceMappingURL=data:application/json;base64,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